// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__-34MI","content":"LoadingOverlay_content__NpHa-","text":"LoadingOverlay_text__+OlUQ"};